if (document.querySelector('.sc-search-result-list')) {
  const searchIt = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // eslint-disable-next-line no-use-before-define
    window.location.href = `${url}?search=${input.value}`;
  };
  const box = document.querySelector('.sc-search-result-list');
  const input = box.querySelector('.input-field__input');
  const url = document.querySelector('.header-search__form').getAttribute('action');
  if (input.value) {
    input.parentNode.classList.add('is-focused');
  }
  input.addEventListener('keyup', (e) => {
    if (e.keyCode === 13) {
      searchIt(e);
    }
  });
  box.querySelector('.btn').addEventListener('click', (e) => {
    searchIt(e);
  });
}
